import { Link } from "react-router-dom";

import { ChevronLeftIcon } from "../../assets/icons";
import { IconButton } from "../IconButton";
import "./PageTitle.scss";

/**
 * PageTitle component
 * @param {{
 *   text: string,
 *   prev?: string | Function,
 *   children?: import("react").ReactNode[] | import("react").ReactNode,
 * }} props
 * @returns
 */
function PageTitle({ text, prev, children }) {
  let backButton = null;

  if (typeof prev === "string") {
    backButton = (
      <Link to={prev}>
        <IconButton icon={<ChevronLeftIcon />} />
      </Link>
    );
  } else if (typeof prev === "function") {
    backButton = <IconButton icon={<ChevronLeftIcon />} onClick={prev} />;
  }

  return (
    <div className="page-title">
      <div className="lbx">
        {backButton}
        <h1>{text}</h1>
      </div>

      <div className="rbx">{children}</div>
    </div>
  );
}

export default PageTitle;
